import http from './http';

// 积分流水导出
export const fetchExportPointsFlow = (data) => {
  return http({
    method: 'POST',
    url: `/sub-order-occ/export/points-flow`,
    data,
    responseType: 'blob',
  });
};
// 积分流水统计
export const fetchSummaryOfPointsFlow = (data) => {
  return http({
    method: 'POST',
    url: `/sub-order-occ/summary/points-flow`,
    data,
  });
};
// 积分流水
export const fetchPointsFlowPage = (data) => {
  return http({
    method: 'POST',
    url: `/sub-order-occ/page/points-flow`,
    data,
  });
};

// 离店回访分类
export const fetchGetVisitCategoryList = () => {
  return http({
    url: `/departure-followup/category/list`,
  });
};
// 离店回访保存
export const fetchSaveDeparture = (data) => {
  return http({
    method: 'POST',
    url: `/departure-followup/save`,
    data,
  });
};
// 离店回访详情
export const fetchDepartureDetail = (data) => {
  return http({
    method: 'POST',
    url: `/departure-followup/detail`,
    data,
  });
};
// 统计
export const fetchDepartureStatistics = (data) => {
  return http({
    method: 'POST',
    url: `/departure-followup/statistics`,
    data,
  });
};
// 离店回访列表
export const fetchDeparturePage = (data) => {
  return http({
    method: 'POST',
    url: `/departure-followup/page/list`,
    data,
  });
};

// 宾客消费
export const fetchConsumeGuestList = (data) => {
  return http({
    method: 'POST',
    url: `/customer-analysis/consume/list`,
    data,
  });
};

// 沉默宾客
export const fetchSilentGuestPage = (data) => {
  return http({
    method: 'POST',
    url: `/customer-analysis/silent/page`,
    data,
  });
};

// 统计用户可用券
export const fetchUserCouponCount = (data) => {
  return http({
    method: 'POST',
    url: `/coupon/user/coupon/count`,
    data,
  });
};

// 一键选券
export const fetchBatchChooseCoupon = (data) => {
  return http({
    method: 'POST',
    url: `/coupon/choose/one-key`,
    data,
  });
};

// 用户荣誉列表
export const fetchHonorList = (params) => {
  return http({
    url: `/account/achievementList`,
    params,
  });
};

// app绑定
export const fetchBindApp = (params) => {
  return http({
    url: `/account/bindCard`,
    params,
  });
};

// app绑定校验
export const fetchBindAppCheck = (params) => {
  return http({
    url: `/account/bindCheck`,
    params,
  });
};

// 根据券ID查询券信息
export const fetchQueryCouponInfoByCodes = (data: Array<string>) => {
  return http({
    url: '/coupon/batch/base/info',
    method: 'POST',
    data,
  });
};
// 充送活动列表
export const fetchActivityHistoryPage = (data) => {
  return http({
    method: 'POST',
    url: `/activity/join/record/list`,
    data,
  });
};

// 赠券
export const fetchGiveAwayCoupon = (data) => {
  return http({
    method: 'POST',
    url: `/give/coupon/give`,
    data,
  });
};

// 赠券列表
export const fetchGiveAwayCouponList = (data) => {
  return http({
    method: 'POST',
    url: `/give/coupon/list`,
    data,
  });
};

// 用户赠券历史
export const fetchGiveAwayCouponHistory = (data) => {
  return http({
    method: 'POST',
    url: `/give/coupon/record/page`,
    data,
  });
};

// 修改优惠券有效期
export const fetchUpdateCouponDate = (data) => {
  return http({
    method: 'PUT',
    url: `/coupon/update`,
    data,
  });
};

// 查询全部会员等级配置
export const fetchAllMemberLevelList = (params) => {
  return http({
    url: `/member-level/list`,
    params,
  });
};

// 用户可购卡列表
export const fetchUserAvailbleCardList = (data) => {
  return http({
    method: 'POST',
    url: `/member-card/user/can-card-list`,
    data,
  });
};

// 充值退款接口
export const fetchRechargeRefund = (data) => {
  return http({
    method: 'POST',
    url: `/transactions/recharge-refund`,
    data,
  });
};

// 检查是否跨夜审
export const fetchTransactionsIsValid = (params: { no: string }) => {
  return http({
    url: `/transactions/${params?.no}/valid`,
    params,
  });
};

// 退款结果查询
export const fetchTransactionsRes = (no) => {
  return http({
    url: `/transactions/refund/status/${no}`,
  });
};

// 检查退卡退款
export const fetchCheckReturnCardMoney = (params: { transactionNo: string }) => {
  return http({
    url: `/member-card/refund/check/card-money`,
    params,
  });
};

// 检查跨夜审退卡退款
export const fetchCheckAcrossNightReturnCardMoney = (params: { transactionNo: string }) => {
  return http({
    url: `/member-card/refund/check/night-audit-card-money`,
    params,
  });
};

// 检查不退款仅退卡
export const fetchCheckOnlyReturnCard = (params: { transactionNo: string }) => {
  return http({
    url: `/member-card/refund/check/card`,
    params,
  });
};

// 退卡退款
export const fetchReturnCardMoney = (data: { remark: string; transactionNo: string }) => {
  return http({
    method: 'POST',
    url: `/member-card/refund/card-money`,
    data,
  });
};

// 跨夜审退卡退款
export const fetchAcrossNightReturnCardMoney = (data: {
  remark: string;
  transactionNo: string;
}) => {
  return http({
    method: 'POST',
    url: `/member-card/refund/night-audit-card-money`,
    data,
  });
};

// 不退款仅退卡
export const fetchOnlyReturnCard = (data: { remark?: string; transactionNo: string }) => {
  return http({
    method: 'POST',
    url: `/member-card/refund/card`,
    data,
  });
};

// 会员充值退款详情
export const fetchMemberRechargeDetail = (params) => {
  return http({
    url: `/member-card/recharge/detail`,
    params,
  });
};

// 会员卡购买订单详情
export const fetchMemberCardDetail = (params) => {
  return http({
    url: `/member-card/order/detail`,
    params,
  });
};

// 会员入住记录
export const fetchCheckinHistoryPageList = (data) => {
  return http({
    method: 'POST',
    url: `/sub-order-occ/checkin/record`,
    data,
  });
};

// 新房主手机号设定
export const fetchSaveNewMasterMobile = (data) => {
  return http({
    method: 'PUT',
    url: `/order/detail/member/master/mobile`,
    data,
  });
};

// 查询会员相关业务是否启用
export const fetchBusinessPaymentType = (params) => {
  return http({
    url: `/payment/type/business/member/info`,
    params,
  });
};

// 根据wyuid获取会员(脱敏)
export const fetchDesensitizedInfoByWyuid = (params) => {
  return http({
    url: `/customers/wyuid`,
    params,
  });
};

// 根据wyuid获取证件号、手机号(明文)
export const fetchCustomerInfoByWyuid = (params) => {
  return http({
    url: `/customers/getByWyuid`,
    params,
  });
};

// 获取会员
export const fetchCustomerInfo = (data) => {
  return http({
    method: 'POST',
    url: `/customers/get`,
    data,
  });
};

// 校验手机号
export const fetchCheckCustomerMobile = (data) => {
  return http({
    method: 'PUT',
    url: `/customers/check`,
    data,
  });
};

// 判断是否在住
export const fetchCheckLeave = (params) => {
  return http({
    url: `/sub-order-occ/check/leave`,
    params,
  });
};

// 宾客列表更新人信息
export const fetchUpdateSingleCustomer = (data) => {
  return http({
    method: 'POST',
    url: `/sub-order-occ/update/leave-member`,
    data,
  });
};

// 批量更新会员信息
export const fetchUpdateCustomer = (data) => {
  return http({
    method: 'PUT',
    url: `/customers/batch`,
    data,
  });
};

// 会员流水
export const fetchAccountFlow = (data) => {
  return http({
    method: 'POST',
    url: `/sub-order-occ/account/flow`,
    data,
  });
};

// 不脱敏
export const fetchDesensitizedCardInfoByWyuid = (params) => {
  return http({
    url: `/sub-order-occ/idCard/info/undesen`,
    params,
  });
};

// 宾客详情基础信息&会员信息&上部分信息
export const fetchCardInfoByWyuid = (params) => {
  return http({
    url: `/sub-order-occ/idCard/info`,
    params,
  });
};

// 获取本店宾客
export const fetchGuestList = (data) => {
  return http({
    method: 'POST',
    url: `/sub-order-occ/list`,
    data,
  });
};

// 宾客查询
export const fetchGuestListByKeyword = (params) => {
  return http({
    url: `/sub-order-occ/search/keyword`,
    params,
  });
};

// 会员卡单价查询
export const fetchQueryMemberCardPrice = () => {
  return http({
    url: `/member-card/price`,
  });
};

// 会员卡购买下单
export const fetchBuyMemberCard = (data) => {
  return http({
    method: 'POST',
    url: `/member-card/order`,
    data,
  });
};

// 会员卡销售人查询
export const fetchQuerySalesperson = (data) => {
  return http({
    url: `/member-card/sales`,
    data,
  });
};

// 计算券金额
export const fetchCouponCalculate = (data) => {
  return http({
    method: 'POST',
    url: `/coupon/calculate`,
    data,
  });
};

// 手工券列表查询
export const fetchManualCouponList = (params) => {
  return http({
    url: `/xz-coupon/list/${params.wyuid}`,
  });
};

// 抖音券列表查询
export const fetchDouyinCouponList = (data) => {
  return http({
    url: `/dy-coupon/list/${data.wyuid}`,
  });
};

// 网鱼券列表查询
export const fetchCouponList = (data) => {
  return http({
    method: 'POST',
    url: `/coupon/user/coupon/list`,
    data,
  });
};

// 选券弹窗-网鱼可用券查询
export const fetchAvailableCouponList = (data) => {
  return http({
    method: 'POST',
    url: '/coupon/availableV2',
    data,
  });
};

// 活动列表
export const fetchActivityList = (params) => {
  return http({
    url: '/activity/list',
    params,
  });
};

// 活动下单
export const fetchActivityOrder = (data) => {
  return http({
    method: 'POST',
    url: '/activity/order',
    data,
  });
};

// 核销券
export const fetchUseXuanzhuCoupon = (data) => {
  return http({
    method: 'PUT',
    url: '/xz-coupon/operation/use',
    data,
  });
};

// 反核销券
export const fetchRevertXuanzhuCoupon = (data) => {
  return http({
    method: 'PUT',
    url: '/xz-coupon/operation/revert',
    data,
  });
};

// 获取会员卡配置
export const getCardSellConfig = () => {
  return http({
    method: 'GET',
    url: '/member-card/query/card-sell-config',
  });
};

// 查询客户赛事信息
export const queryGuestGameList = (data) => {
  return http({
    method: 'GET',
    url: `/yooplay/customers?${data}`,
  });
};

// 售卡助手测算
export const saleCardHelperDetail = (data) => {
  return http({
    method: 'POST',
    url: `/sale-card-helper/detail`,
    data,
  });
};

// 查询可用的售卡助手配置
export const queryCardSellAvailable = () => {
  return http({
    method: 'GET',
    url: '/sale-card-helper/available',
  });
};

// 检查手机号是否冲突
export const checkUserPhoneNo = (data) => {
  return http({
    method: 'POST',
    url: '/sms-code/check',
    data,
  });
};

// 发送验证码
export const sendSMSCheckCode = (data) => {
  return http({
    method: 'POST',
    url: '/sms-code/send',
    data,
  });
};

// 校验用户手机号
export const verifyUserPhoneNo = (data) => {
  return http({
    method: 'POST',
    url: '/sms-code/verify',
    data,
  });
};

// 宾客资料检核列表
export const fetchCheckGuestInfosList = (data) => {
  return http({
    method: 'POST',
    url: '/sub-order-occ/page',
    data,
  });
};

// 宾客资料检核列表-入住人数统计
export const fetchGuestCount = (data) => {
  return http({
    method: 'POST',
    url: '/sub-order-occ/count',
    data,
  });
};

// 在住宾客检核列表
export const fetchCheckCurrentGuestList = (data) => {
  return http({
    method: 'POST',
    url: '/sub-order-occ/list/group',
    data,
  });
};

// 注销宾客检查
export const fetchCancelMemberCheck = (data) => {
  return http({
    method: 'POST',
    url: `/customers/logoff-business-check`,
    data,
  });
};
